var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-content" }, [
      _c("div", { attrs: { id: "boxloading" } }),
      _vm._v(" "),
      _c("div", { staticClass: "main-content-inner" }, [
        _c(
          "div",
          {
            staticClass: "breadcrumbs ace-save-state",
            attrs: { id: "breadcrumbs" }
          },
          [
            _c(
              "ul",
              { staticClass: "breadcrumb" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "router-link",
                  { attrs: { tag: "li", to: { name: "user" } } },
                  [_c("a", [_vm._v("ユーザー")])]
                ),
                _vm._v(" "),
                _c("li", { staticClass: "active" }, [
                  _vm._v("新規ユーザー登録")
                ])
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "page-content register_user" }, [
          _vm.loading
            ? _c("div", { attrs: { id: "loading" } }, [
                _c("div", { staticClass: "loadingMsg" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _vm.message_success
              ? _c("div", { staticClass: "alert alert-success" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.message_success) +
                      "\n          "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.message_error
              ? _c("div", { staticClass: "alert alert-danger" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.message_error) +
                      "\n          "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-sm-10" }, [
                _c("div", { staticClass: "profile-user-info" }, [
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("ユーザーID")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "userid_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.userId,
                            expression: "userInfor.userId"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          placeholder: "ユーザーID",
                          id: "userid",
                          type: "text",
                          name: "userId"
                        },
                        domProps: { value: _vm.userInfor.userId },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "userId",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("ログインパスワード")
                    ]),
                    _vm._v(" "),
                    _c("label", { staticClass: "clearfix cusrow" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "password_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.password,
                            expression: "userInfor.password"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          id: "password",
                          placeholder: "パスワード",
                          name: "password",
                          type: "password"
                        },
                        domProps: { value: _vm.userInfor.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "password",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "newpassword-showhide" }, [
                      _c(
                        "span",
                        {
                          staticClass: "show-password",
                          on: {
                            click: function($event) {
                              _vm.showhidePassword(
                                "password",
                                "show-password",
                                "newpassword-showhide"
                              )
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../../static/img/eye_off.png"),
                              width: "30"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "hide-password",
                          on: {
                            click: function($event) {
                              _vm.showhidePassword(
                                "password",
                                "hide-password",
                                "newpassword-showhide"
                              )
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../../static/img/eye_on.png"),
                              width: "30"
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "warringu" }, [
                      _vm._v(
                        "\n                    ログインパスワードは英大文字、英小文字、数字を組み合わせた8文字以上64文字以内で入力してください。\n                  "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("ユーザー名（登録名）")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "name_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.name,
                            expression: "userInfor.name"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          type: "text",
                          id: "name",
                          placeholder: "ユーザー名"
                        },
                        domProps: { value: _vm.userInfor.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.userInfor, "name", $event.target.value)
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("ユーザー名（ふりがな）")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "furigana_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.furigana,
                            expression: "userInfor.furigana"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          type: "text",
                          id: "furigana",
                          placeholder: "ふりがな"
                        },
                        domProps: { value: _vm.userInfor.furigana },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "furigana",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("メールアドレス")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "mailaddress_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.email,
                            expression: "userInfor.email"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          type: "text",
                          id: "mailaddress",
                          placeholder: "example@example.com"
                        },
                        domProps: { value: _vm.userInfor.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "email",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("暗証番号")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "passcode_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.passCode,
                            expression: "userInfor.passCode"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          type: "text",
                          id: "passcode",
                          placeholder: "0000"
                        },
                        domProps: { value: _vm.userInfor.passCode },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "passCode",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("組織管理権限")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.isAdmin,
                            expression: "userInfor.isAdmin"
                          }
                        ],
                        staticClass: "ace ace-switch ace-switch-4",
                        attrs: { name: "switch-field-1", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.userInfor.isAdmin)
                            ? _vm._i(_vm.userInfor.isAdmin, null) > -1
                            : _vm.userInfor.isAdmin
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.userInfor.isAdmin,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.userInfor.isAdmin = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.userInfor.isAdmin = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(_vm.userInfor, "isAdmin", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "lbl" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("ゲート設定権限")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.isPhoneAdmin,
                            expression: "userInfor.isPhoneAdmin"
                          }
                        ],
                        staticClass: "ace ace-switch ace-switch-4",
                        attrs: { name: "switch-field-1", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.userInfor.isPhoneAdmin)
                            ? _vm._i(_vm.userInfor.isPhoneAdmin, null) > -1
                            : _vm.userInfor.isPhoneAdmin
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.userInfor.isPhoneAdmin,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.userInfor.isPhoneAdmin = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.userInfor.isPhoneAdmin = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(_vm.userInfor, "isPhoneAdmin", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "lbl" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("鍵共有権限")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.shareKeyBeValid,
                            expression: "userInfor.shareKeyBeValid"
                          }
                        ],
                        staticClass: "ace ace-switch ace-switch-4",
                        attrs: { name: "switch-field-1", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.userInfor.shareKeyBeValid)
                            ? _vm._i(_vm.userInfor.shareKeyBeValid, null) > -1
                            : _vm.userInfor.shareKeyBeValid
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.userInfor.shareKeyBeValid,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.userInfor.shareKeyBeValid = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.userInfor.shareKeyBeValid = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(_vm.userInfor, "shareKeyBeValid", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "lbl" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("ステータス")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.isValid,
                            expression: "userInfor.isValid"
                          }
                        ],
                        staticClass: "ace ace-switch ace-switch-4",
                        attrs: { name: "switch-field-1", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.userInfor.isValid)
                            ? _vm._i(_vm.userInfor.isValid, null) > -1
                            : _vm.userInfor.isValid
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.userInfor.isValid,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.userInfor.isValid = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.userInfor.isValid = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(_vm.userInfor, "isValid", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "lbl" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("備考.1")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "option1_error" }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.option1,
                            expression: "userInfor.option1"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "option1", placeholder: "備考.1" },
                        domProps: { value: _vm.userInfor.option1 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "option1",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("備考.2")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "option2_error" }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.option2,
                            expression: "userInfor.option2"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "option2", placeholder: "備考.2" },
                        domProps: { value: _vm.userInfor.option2 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "option2",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12" }, [
                    _c(
                      "div",
                      { staticClass: "action_box" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "btn cancel_bottom",
                            attrs: { to: { name: "user" } }
                          },
                          [
                            _vm._v(
                              "\n                      キャンセル\n                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-info save_bottom",
                            attrs: { type: "button" },
                            on: { click: _vm.validateBeforeSubmit }
                          },
                          [
                            _vm._v(
                              "\n                      ユーザーを登録\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
      _vm._v(" "),
      _c("a", { attrs: { href: "#/" } }, [_vm._v("ダッシュボード")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [
        _c("h3", [_vm._v("新規ユーザー登録")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12 col-sm-2 center userav" }, [
      _c("span", { staticClass: "profile-picture" }, [
        _c("img", {
          staticClass: "editable img-responsive",
          staticStyle: { width: "150px" },
          attrs: {
            id: "user_avatar",
            alt: "user avatar",
            src: require("../../../static/images/avatars/default-avatar.png"),
            width: "150",
            height: "150"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "btn-upload",
          staticStyle: {
            background: "black",
            color: "white",
            padding: "5px 15px",
            "margin-top": "10px",
            cursor: "pointer"
          },
          attrs: { for: "file_user_avatar" }
        },
        [
          _vm._v("\n                画像ファイルを選択\n                "),
          _c("input", {
            staticStyle: { display: "none" },
            attrs: {
              type: "file",
              name: "avatar",
              id: "file_user_avatar",
              accept: "image/png"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "error_m", attrs: { id: "fileimg_error" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ab9668c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab9668c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/UserAdd.vue
// module id = null
// module chunks = 